export default __webpack_public_path__ + "static/media/b07.4fc5cde9.jpg";